import $foreign from "./foreign.cjs";
var addBack = $foreign.addBack;
var addTestLoadedMarker = $foreign.addTestLoadedMarker;
var empty = $foreign.empty;
var filter = $foreign.filter;
var focus = $foreign.focus;
var getAttr = $foreign.getAttr;
var getData = $foreign.getData;
var getDocument = $foreign.getDocument;
var length = $foreign.length;
var logErrorOnElement = $foreign.logErrorOnElement;
var one = $foreign.one;
var parents = $foreign.parents;
var postImpl = $foreign.postImpl;
var removeAttr = $foreign.removeAttr;
var selector = $foreign.selector;
var setData = $foreign.setData;
var toArray = $foreign.toArray;
var trigger = $foreign.trigger;
var wrapNode = $foreign.wrapNode;
export { addBack, addTestLoadedMarker, empty, filter, focus, getAttr, getData, getDocument, length, logErrorOnElement, one, parents, postImpl, removeAttr, selector, setData, toArray, trigger, wrapNode };
